export default __webpack_public_path__ + "static/media/dark.10b30add.svg";